import { render, staticRenderFns } from "./aiConfig.vue?vue&type=template&id=1595d385&scoped=true"
import script from "./aiConfig.vue?vue&type=script&lang=js"
export * from "./aiConfig.vue?vue&type=script&lang=js"
import style0 from "./aiConfig.vue?vue&type=style&index=0&id=1595d385&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595d385",
  null
  
)

export default component.exports